import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import {
  KibDeleteFillIcon,
  KibDownloadIcon,
  KibVisibilityOnIcon,
} from '@chewy/kib-icons-react'
import classNames from 'classnames'

import type { AttachmentProps } from '~/components/common/inputs/attachment/Attachment'

import styles from './RhapKibAttachment.module.scss'

const RhapKibAttachment = ({
  file,
  hideDownload = false,
  hideDelete = false,
  hidePreview = false,
  deleteDisabled,
  disabled = false,
  onDownloadRequested,
  onPreviewRequested,
  onDeleteRequested,
}: AttachmentProps) => {
  const { t } = useTranslation('Common')
  return (
    <div
      className={classNames(styles.attachmentItem, {
        [styles.disabled]: disabled,
      })}
      key={file.id}
    >
      <span className={styles.attachmentName}>{file.name}</span>
      {file.required && (
        <span className={styles.stateLabel}>{t('Common:REQUIRED')}</span>
      )}
      <span className={styles.buttonGroup}>
        {!hidePreview && onPreviewRequested && (
          <KibButtonNew
            iconOnly
            icon={<KibVisibilityOnIcon />}
            size="medium"
            theme="utility"
            onClick={() => onPreviewRequested(file)}
          >
            {t('Common:PREVIEW_ACTION')}
          </KibButtonNew>
        )}
        {!hideDelete && onDeleteRequested && (
          <>
            <span className={styles.divider} />
            <KibButtonNew
              iconOnly
              disabled={deleteDisabled}
              icon={<KibDeleteFillIcon />}
              size="medium"
              theme="utility"
              onClick={() => onDeleteRequested(file)}
            >
              {t('Common:DELETE_ACTION')}
            </KibButtonNew>
          </>
        )}
        {!hideDownload && onDownloadRequested && (
          <>
            <span className={styles.divider} />
            <KibButtonNew
              iconOnly
              icon={<KibDownloadIcon />}
              size="medium"
              theme="utility"
              onClick={() => onDownloadRequested(file)}
            >
              {t('Common:DOWNLOAD_ACTION')}
            </KibButtonNew>
          </>
        )}
      </span>
    </div>
  )
}

export default RhapKibAttachment
